<div *ngIf="isOpen" class="acct-type-overlay" (click)="close()">
  <div class="acct-type-modal" (click)="$event.stopPropagation()">
    <div class="acct-modal-header">
      <h2>{{ 'ACCOUNT_TYPES.CHANGE_TITLE' | translate }}</h2>
      <button type="button" class="acct-modal-close" [attr.aria-label]="'COMMON.CLOSE' | translate" (click)="close()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <p class="acct-modal-subtitle">{{ 'ACCOUNT_TYPES.CURRENT_ACCOUNT' | translate }}<strong>{{ currentRoleLabelKey | translate }}</strong>{{ 'ACCOUNT_TYPES.SELECT_NEW_TYPE' | translate }}</p>

    <div *ngIf="acctError" class="alert-box alert-error">
      <i class="fas fa-exclamation-triangle"></i>
      <span>{{ acctError }}</span>
    </div>

    <div class="role-cards-grid">
      <button
        *ngFor="let role of roleOptions"
        type="button"
        class="role-card"
        [class.role-card-selected]="selectedRole === role.id"
        [class.role-card-current]="currentRole === role.id"
        [disabled]="currentRole === role.id"
        (click)="selectRole(role.id)"
      >
        <span class="role-card-icon">{{ role.icon }}</span>
        <span class="role-card-title">{{ role.titleKey | translate }}</span>
        <span class="role-card-desc">{{ role.descriptionKey | translate }}</span>
        <span *ngIf="currentRole === role.id" class="role-card-current-badge">{{ 'ACCOUNT_TYPES.CURRENT' | translate }}</span>
      </button>
    </div>

    <div *ngIf="selectedRole === 3" class="acct-extra-fields">
      <h5><i class="fas fa-guitar"></i>{{ 'ACCOUNT_TYPES.BAND_ARTIST_DATA' | translate }}</h5>
      <label class="profile-field">
        <span>{{ 'ACCOUNT_TYPES.BAND_ARTIST_NAME' | translate }}</span>
        <input type="text" [(ngModel)]="acctDisplayName" maxlength="100" />
        <small class="field-help">{{ 'ACCOUNT_TYPES.VISIBLE_NAME_HINT' | translate }}</small>
      </label>
      <label class="profile-field">
        <span>{{ 'DASHBOARD.NUMBER_OF_MEMBERS' | translate }}<small>{{ 'COMMON.OPTIONAL_PARENS' | translate }}</small></span>
        <input type="number" [(ngModel)]="acctMemberCount" min="1" max="100" [placeholder]="'PROFILE_EDIT.MEMBER_COUNT_PLACEHOLDER' | translate" />
      </label>
      <label class="profile-field">
        <span>{{ 'ACCOUNT_TYPES.SHORT_BIO' | translate }}<small>{{ 'COMMON.OPTIONAL_PARENS' | translate }}</small></span>
        <textarea [(ngModel)]="acctBio" rows="3" [placeholder]="'PROFILE_EDIT.ARTIST_BIO_PLACEHOLDER' | translate"></textarea>
      </label>
    </div>

    <div *ngIf="selectedRole === 2" class="acct-extra-fields">
      <h5><i class="fas fa-building"></i>{{ 'ACCOUNT_TYPES.VENUE_DATA' | translate }}</h5>
      <label class="profile-field">
        <span>{{ 'ACCOUNT_TYPES.VENUE_NAME' | translate }}</span>
        <input type="text" [(ngModel)]="acctDisplayName" maxlength="100" />
        <small class="field-help">{{ 'ACCOUNT_TYPES.VISIBLE_NAME_HINT' | translate }}</small>
      </label>
      <label class="profile-field">
        <span>{{ 'ACCOUNT_TYPES.COMMERCIAL_NAME' | translate }}<small>{{ 'COMMON.OPTIONAL_PARENS' | translate }}</small></span>
        <input type="text" [(ngModel)]="acctSocialName" maxlength="100" [placeholder]="'ACCOUNT_TYPES.COMPANY_PLACEHOLDER' | translate" />
        <small class="field-help">{{ 'ACCOUNT_TYPES.LEGAL_NAME_HINT' | translate }}</small>
      </label>
      <label class="profile-field">
        <span>{{ 'ACCOUNT_TYPES.CAPACITY' | translate }}<small>{{ 'COMMON.OPTIONAL_PARENS' | translate }}</small></span>
        <input type="number" [(ngModel)]="acctCapacity" min="1" [placeholder]="'PROFILE_EDIT.CAPACITY_PLACEHOLDER' | translate" />
      </label>
      <label class="profile-field">
        <span>{{ 'COMMON.ADDRESS' | translate }}<small>{{ 'COMMON.OPTIONAL_PARENS' | translate }}</small></span>
        <input type="text" [(ngModel)]="acctAddress" maxlength="255" [placeholder]="'PROFILE_EDIT.ADDRESS_PLACEHOLDER' | translate" />
      </label>
    </div>

    <div *ngIf="selectedRole === 1" class="acct-extra-fields">
      <h5><i class="fas fa-user"></i>{{ 'ACCOUNT_TYPES.ACCOUNT_DATA' | translate }}</h5>
      <label class="profile-field">
        <span>{{ 'COMMON.NAME' | translate }}</span>
        <input type="text" [(ngModel)]="acctDisplayName" maxlength="100" />
        <small class="field-help">{{ 'ACCOUNT_TYPES.VISIBLE_NAME_HINT' | translate }}</small>
      </label>
    </div>

    <div class="acct-modal-footer">
      <button type="button" class="secondary-button" (click)="close()">{{ 'COMMON.CANCEL' | translate }}</button>
      <button
        type="button"
        class="primary-button"
        [disabled]="!selectedRole || isChangingAccountType"
        (click)="confirmAccountTypeChange()"
      >
        <i class="fas fa-check-circle"></i>
        {{ isChangingAccountType ? ('COMMON.SAVING' | translate) : ('ACCOUNT_TYPES.CONFIRM_CHANGE' | translate) }}
      </button>
    </div>
  </div>
</div>
